import React from 'react';
import { api } from '@/lib/api';
import { Badge } from '@/components/ui/badge';

export const STATES = {
  draft: { id: 'Draf', en: 'Draft', cls: 'bg-slate-100 text-slate-700' },
  running: { id: 'Aktif', en: 'Running', cls: 'bg-emerald-50 text-emerald-700' },
  maintenance: { id: 'Dalam perbaikan', en: 'Under maintenance', cls: 'bg-amber-50 text-amber-700' },
  disposed: { id: 'Dilepas', en: 'Disposed', cls: 'bg-slate-100 text-slate-600' },
  sold: { id: 'Dijual', en: 'Sold', cls: 'bg-sky-50 text-sky-700' },
  written_off: { id: 'Dihapusbukukan', en: 'Written off', cls: 'bg-rose-50 text-rose-700' },
};
export const isActive = (s) => s === 'running' || s === 'maintenance';
export const isGone = (s) => ['disposed', 'sold', 'written_off'].includes(s);

export const StateBadge = ({ state, lang = 'id', testid }) => {
  const s = STATES[state] || STATES.running;
  return <Badge variant="outline" className={`rounded-full whitespace-nowrap ${s.cls}`} data-testid={testid}>{s[lang] || s.id}</Badge>;
};

export const METHODS = [{ value: 'straight', id: 'Garis lurus', en: 'Straight-line' }, { value: 'declining', id: 'Saldo menurun ganda', en: 'Double declining' }];
export const FISCAL = [
  { value: '', id: 'Tidak dihitung', en: 'Not tracked' }, { value: '1', id: 'Kelompok 1 (4 th · 25% / 50%)', en: 'Group 1 (4 yr)' }, { value: '2', id: 'Kelompok 2 (8 th · 12,5% / 25%)', en: 'Group 2 (8 yr)' },
  { value: '3', id: 'Kelompok 3 (16 th · 6,25% / 12,5%)', en: 'Group 3 (16 yr)' }, { value: '4', id: 'Kelompok 4 (20 th · 5% / 10%)', en: 'Group 4 (20 yr)' },
  { value: 'building_perm', id: 'Bangunan permanen (20 th · 5%)', en: 'Permanent building' }, { value: 'building_nonperm', id: 'Bangunan tidak permanen (10 th · 10%)', en: 'Non-permanent building' },
];
export const PAID_WITH = (id) => [{ value: 'bank', label: 'Bank' }, { value: 'cash', label: id ? 'Kas' : 'Cash' }, { value: 'payable', label: id ? 'Utang (kredit)' : 'Payable' }, { value: 'none', label: id ? 'Tanpa jurnal (sudah dicatat)' : 'No journal' }];
export const DOC_KINDS = (id) => [{ value: 'invoice', label: id ? 'Faktur pembelian' : 'Invoice' }, { value: 'bpkb', label: 'BPKB / STNK' }, { value: 'certificate', label: id ? 'Sertifikat' : 'Certificate' }, { value: 'warranty', label: id ? 'Kartu garansi' : 'Warranty' }, { value: 'manual', label: id ? 'Manual / panduan' : 'Manual' }, { value: 'other', label: id ? 'Lainnya' : 'Other' }];
export const EVENT_LABEL = { transfer: 'Transfer lokasi', handover: 'Serah terima', maintenance: 'Perawatan', revaluation: 'Kapitalisasi', impairment: 'Penurunan nilai', status: 'Status', audit: 'Opname', note: 'Catatan' };

/** Open a PDF endpoint (relative to /companies/{id}) in a new tab with auth. */
export const openPdf = async (companyId, path) => {
  const res = await api.get(`/companies/${companyId}${path}`, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const monthLabel = (p) => (p ? new Date(`${p}-01`).toLocaleDateString('id-ID', { month: 'short', year: 'numeric' }) : '—');
